import React, { useRef,useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, Sphere } from "@react-three/drei";
import { pointsInner, pointsOuter } from "./utils";
import { useNavigate } from "react-router-dom";
import ForgotPasswordModal from "../components/auth/ForgotPassword";
import { useAuth } from '../components/auth/AuthContext';
import axios from "axios";

const ParticleRing = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [show,setShow]=useState(true);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [password,setPassword]=useState('');
  const { login } = useAuth();


  const handleSignIn = async () => {
    console.log("Inside Login");
    try {
      const response = await axios.post("http://localhost:8080/signin", { email, password }, { withCredentials: true });
      if (response.data.success) {
        console.log("login success")
      login(); 
      navigate('/search-recipe');
      } 
    } catch (error) {
      console.error(error);
    }
  };

  const validateEmail = () => {
    if (!email.includes('@') || !email.includes('.com' )) {
      setEmailError('Invalid email address');
    } else {
      setEmailError('');
    }
  };

  return (
    <div className="relative">
      <Canvas
        camera={{
          position: [-1, 4.5,10],
        }}
        style={{ height: "100vh" }}
        className="bg-purple-50		"
      >
        <OrbitControls maxDistance={20} minDistance={10} />
        <directionalLight />
        <pointLight position={[-30, 0, -30]} power={10.0} />
        <PointCircle />
      </Canvas>

      <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]  ">
      <div className="  bottom-0 leading-5 h-full w-full overflow-hidden sm:block hidden">
      <div className="relative min-h-screen sm:flex sm:flex-row justify-center bg-transparent rounded-3xl shadow-xl">
        <div className="flex-col flex self-center lg:px-14 sm:max-w-4xl xl:max-w-md z-10">
          <div className="self-start hidden lg:flex flex-col  mb-20">
            <h1 className="my-3 font-semibold text-purple-700 text-5xl bg-orange-100 bg-blend-normal	opacity-90 ">Welcome back.</h1>
            <p className="pr-3 text-md text-black opacity-80">
            Reignite your passion for cooking with Recipe Alchemy!
            Lets dive to a world where creativity meets culinary expertise.
            Transform ordinary ingredients into extraordinary recipes together. 
            </p>
          </div>
        </div>
        <div className="flex justify-center self-center z-10 ">
          <div className="p-12 bg-white opacity-95 mx-auto rounded-3xl w-96">
            <div className="mb-7">
              <h3 className="font-semibold text-2xl text-gray-800">Sign In</h3>
              <p className="text-gray-400">
                Don't have an account? <a href="/signup"
                 className="text-sm text-purple-700 hover:text-purple-700 underline cursor-pointer underline" >Sign Up</a>
              </p>
            </div>
            <div className="space-y-6">
              <div>
              <input
        className={`w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400 ${emailError ? 'border-red-500' : ''}`}
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onBlur={validateEmail}
      />
      {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
              </div>
              <div className="relative">
                <input
                  placeholder="Password"
                  type={show ? 'password' : 'text'}
                  className="text-sm text-black-200 px-4 py-3 rounded-lg w-full bg-gray-200 focus:bg-gray-100 border border-gray-200 focus:outline-none focus:border-purple-400"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
               />
                <div className="flex items-center absolute inset-y-0 right-0 mr-3 text-sm leading-5">
                  <svg
                    onClick={() => setShow(!show)}
                    className="{{{'hidden': !show, 'block': show}}"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                    ></path>
                  </svg>
                  <svg
                    className="{{{'block': !show, 'hidden': show}}"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 512"
                  >
                    <path
                      fill="currentColor"
                      d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07a32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div className="text-sm ml-auto">
                  
                  <div onClick={()=>{
                            setIsOpen(true)

                  }} className="text-purple-700 hover:text-purple-600">
                    Forgot your password?
                  </div>
                  <ForgotPasswordModal isOpen={isOpen} setIsOpen={setIsOpen}/>
                </div>
              </div>
              <div
                  className="w-full flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500"
               onClick={handleSignIn}
               >
                  Sign in
              </div>
              <div className="flex items-center justify-center space-x-2 my-5">
                <span className="h-px w-16 bg-gray-300"></span>
                <span className="text-gray-500 font-normal">or</span>
                <span className="h-px w-16 bg-gray-300"></span>
              </div>
              <div className="flex justify-center gap-5 w-full">
                <button
                  type="submit"
                  className="w-full flex items-center justify-center mb-6 md:mb-0 hover:text-white border border-gray-300 hover:border-gray-900 hover:bg-gray-900 text-sm text-gray-500 p-3 rounded-lg tracking-wide font-medium cursor-pointer transition ease-in duration-500"
                >
                  <svg
                    className="w-4 mr-2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="#EA4335"
                      d="M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582L19.91 3C17.782 1.145 15.055 0 12 0 7.27 0 3.198 2.698 1.24 6.65l4.026 3.115Z"
                    ></path>
                    <path
                      fill="#34A853"
                      d="M16.04 18.013c-1.09.703-2.474 1.078-4.04 1.078a7.077 7.077 0 0 1-6.723-4.823l-4.04 3.067A11.965 11.965 0 0 0 12 24c2.933 0 5.735-1.043 7.834-3l-3.793-2.987Z"
                    ></path>
                    <path
                      fill="#4A90E2"
                      d="M19.834 21c2.195-2.048 3.62-5.096 3.62-9 0-.71-.109-1.473-.272-2.182H12v4.637h6.436c-.317 1.559-1.17 2.766-2.395 3.558L19.834 21Z"
                    ></path>
                    <path
                      fill="#FBBC05"
                      d="M5.277 14.268A7.12 7.12 0 0 1 4.909 12c0-.782.125-1.533.357-2.235L1.24 6.65A11.934 11.934 0 0 0 0 12c0 1.92.445 3.73 1.237 5.335l4.04-3.067Z"
                    ></path>
                  </svg>
                  <span>Google</span>
                </button>
              </div>
            </div>
            <div className="mt-7 text-center text-black-300 text-xs">
              <span>
                Copyright © 2024 RecipeAlchemy
              </span>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
      {/* mobile view */}
      <div className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]  ">
      <div className="  bottom-0 mt-40 leading-5 h-full w-full overflow-hidden lg:hidden">
      <div className="relative min-h-screen sm:flex sm:flex-row justify-center bg-transparent rounded-3xl shadow-xl">
        <div className="flex-col flex self-center lg:px-14 sm:max-w-4xl xl:max-w-md z-10">
          <div className="self-start  lg:flex flex-col  self-center">
            <h1 className="my-3 font-semibold text-purple-700 text-5xl bg-orange-100 bg-blend-normal opacity-90 ">Welcome back.</h1>
          </div>
        </div>
        <div className="flex justify-center self-center z-10 ">
          <div className="p-12 bg-purple-200 opacity-95 mx-auto rounded-3xl w-96">
            <div className="mb-7">
              <h3 className="font-semibold text-2xl text-black">Sign In</h3>
              <p className="text-gray-400">
                Don't have an account? <a href="/signup"
                 className="text-sm text-purple-700 hover:text-purple-700 underline cursor-pointer underline" >Sign Up</a>
              </p>
            </div>
            <div className="space-y-6">
              <div>
              <input
        className={`w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400 ${emailError ? 'border-red-500' : ''}`}
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onBlur={validateEmail}
      />
      {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
              </div>
              <div className="relative">
                <input
                  placeholder="Password"
                  type={show ? 'password' : 'text'}
                  className="text-sm text-black-200 px-4 py-3 rounded-lg w-full bg-gray-200 focus:bg-gray-100 border border-gray-200 focus:outline-none focus:border-purple-400"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className="flex items-center absolute inset-y-0 right-0 mr-3 text-sm leading-5">
                  <svg
                    className="{{{'hidden': !show, 'block': show}}"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                    ></path>
                  </svg>
                  <svg
                    className="{{{'block': !show, 'hidden': show}}"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 512"
                  >
                    <path
                      fill="currentColor"
                      d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07a32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                    ></path>
                  </svg>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div className="text-sm ml-auto">
                  
                  <div onClick={()=>{
                            setIsOpen(true)

                  }} className="text-purple-700 hover:text-purple-600">
                    Forgot your password?
                  </div>
                  <ForgotPasswordModal isOpen={isOpen} setIsOpen={setIsOpen}/>
                </div>
              </div>
              <div>
              <div
                  className="w-full flex justify-center bg-purple-700 hover:bg-purple-900 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500"
               onClick={handleSignIn}
               >
                  Sign in
              </div>
              </div>
              <div className="flex items-center justify-center space-x-2 my-5">
                <span className="h-px w-16 bg-gray-300"></span>
                <span className="text-gray-500 font-normal">or</span>
                <span className="h-px w-16 bg-gray-300"></span>
              </div>
              <div className="flex justify-center gap-5 w-full">
                <button
                  type="submit"
                  className="w-full flex items-center justify-center mb-6 md:mb-0 border border-gray-300 bg-gray-900 hover:bg-orange-400 hover:text-black text-sm text-white p-3 rounded-lg tracking-wide font-medium cursor-pointer transition ease-in duration-500"
                >
                  <svg
                    className="w-4 mr-2"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="#EA4335"
                      d="M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582L19.91 3C17.782 1.145 15.055 0 12 0 7.27 0 3.198 2.698 1.24 6.65l4.026 3.115Z"
                    ></path>
                    <path
                      fill="#34A853"
                      d="M16.04 18.013c-1.09.703-2.474 1.078-4.04 1.078a7.077 7.077 0 0 1-6.723-4.823l-4.04 3.067A11.965 11.965 0 0 0 12 24c2.933 0 5.735-1.043 7.834-3l-3.793-2.987Z"
                    ></path>
                    <path
                      fill="#4A90E2"
                      d="M19.834 21c2.195-2.048 3.62-5.096 3.62-9 0-.71-.109-1.473-.272-2.182H12v4.637h6.436c-.317 1.559-1.17 2.766-2.395 3.558L19.834 21Z"
                    ></path>
                    <path
                      fill="#FBBC05"
                      d="M5.277 14.268A7.12 7.12 0 0 1 4.909 12c0-.782.125-1.533.357-2.235L1.24 6.65A11.934 11.934 0 0 0 0 12c0 1.92.445 3.73 1.237 5.335l4.04-3.067Z"
                    ></path>
                  </svg>
                  <span>Google</span>
                </button>
              </div>
            </div>
            <div className="mt-7 text-center text-black-300 text-xs">
              <span>
                Copyright © 2024 RecipeAlchemy
              </span>
            </div>
          </div>
        </div>
      </div>
     </div>
      </div>
    </div>
  );
};

const PointCircle = () => {
  const ref = useRef(null);

  useFrame(({ clock }) => {
    if (ref.current?.rotation) {
      ref.current.rotation.z = clock.getElapsedTime() * 0.05;
    }
  });

  return (
    <group ref={ref}>
      {pointsInner.map((point) => (
        <Point key={point.idx} position={point.position} color="purple" />
      ))}
      {pointsOuter.map((point) => (
        <Point key={point.idx} position={point.position} color="purple" />
      ))}
    </group>
  );
};

const Point = ({ position, color }) => {
  return (
    <Sphere position={position} args={[0.1, 10, 10]}>
      <meshStandardMaterial
        emissive={color}
        emissiveIntensity={0.5}
        roughness={0.5}
        color={color}
      />
    </Sphere>
  );
};

export default ParticleRing;